import React from 'react';
import styled from 'styled-components';
import { paragraphMixin } from '../theme/mixins';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const GridContainer3 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 24px;
  margin: 0px;

  .slider {
    margin-bottom: 15px;
  }
  @media only screen and (max-width: 1300px) {
    grid-template-columns: 1fr 1fr;
  }
  @media only screen and (max-width: 460px) {
    grid-template-columns: 1fr;
  }
`;

const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  img {
    height: 230px;
    object-fit: cover;
    @media only screen and (max-width: 1300px) {
      height: 150px;
    }
  }
  p {
    ${paragraphMixin}
    &.grid-title {
      font-size: ${(props) => props.theme.fontSize['xl']};
      @media only screen and (max-width: 768px) {
        font-size: ${(props) => props.theme.fontSize['lg']};
      }
      font-weight: 600;
      margin-top: 8px;
    }
  }
`;

const Image = styled.img`
  width: 100%;
  max-height: 500px;
  border-radius: 16px;
`;

// Styling for Cabin format
const GridContainer3Cabin = styled(GridContainer3)`
  grid-template-columns: repeat(3, minmax(0, 1fr));
  @media only screen and (max-width: 1300px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media only screen and (max-width: 500px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  p {
    margin-top: 10px;
  }
`;

// ****** USED FOR DISPLAYING EVERTHING ELSE ******

const settings = {
  arrows: true,
  dots: true,
  infinite: true,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

// Display grid 3 wide / 2 Text areas
export const ImageGrid3 = ({ array, height }) => (
  <GridContainer3>
    {array.map((element, index) => (
      <GridItem key={`${element.title}-${index}`}>
        {element.images.length > 1 && (
          <Slider className="slider" {...settings}>
            <div>1</div>
            <div>
              <h3>2</h3>
            </div>
          </Slider>
        )}
        {element.images.length && <Image alt="" src={element.images[0]} height={height} />}

        <p className="grid-title">{element.title}</p>
        <p className="grid-description">{element.description}</p>
      </GridItem>
    ))}
  </GridContainer3>
);

// ****** USED FOR DISPLAYING CABINS ******
// Display 3 text areas with the 1st/2nd as bold

export const ImageGrid3Cabin = ({ array, height }) => (
  <GridContainer3Cabin>
    {array.map((key, index) => (
      <GridItem key={`${key.title}-${index}`}>
        {key.images.length === 1 && <Image src={key.images[0]} height={height} />}
        {key.images.length > 1 && (
          <Slider className="slider" height={height} {...settings}>
            {key.images.map((x) => (
              <div>
                <Image src={x} height={height} />
              </div>
            ))}
          </Slider>
        )}
        <p className="grid-title">{key.title}</p>
        <p className="grid-description1">{key.description1}</p>
        <p className="grid-description2">{key.description2}</p>
      </GridItem>
    ))}
  </GridContainer3Cabin>
);
